

















import Vue from "vue";
export default Vue.extend({
  props: {
    list: {
      type: Array,
      default: (): Array<any> => []
    },
    dragable: {
      type: Boolean,
      default: false
    },
    drageAnimation: {
      type: Number,
      default: 300
    },
    ghostClass: {
      type: String,
      default: "ghost"
    },
    drageHandler: {
      type: String
    },
    tag: {
      type: String,
      default: "div"
    },
    value: {
      type: Array,
      default: (): Array<any> => []
    },
    onMove: {
      type: Function
    },
    dragGroup: {
      type: String,
      validator() {
        if (this.dragable) {
          return true;
        }
        return false;
      }
    }
  },
  data() {
    return {
      drag: false
    };
  },
  methods: {
    slotData(item: any, type: any) {
      if (!type) return item;

      if (type && typeof type === "string") {
        return item[type] || {};
      } else if (type && Array.isArray(type)) {
        const obj: any = {};
        type.forEach((el: any) => {
          if (item[el]) {
            obj[el] = item[el];
          }
        });
      }
    }
  },
  computed: {
    bindPropsHandler() {
      const obj: any = {};
      if (this.drageHandler) {
        obj["handle"] = this.drageHandler;
      }

      return obj;
    }
  }
});
